import React, {Component} from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './styles.css';
import {getVacations, editVacation, deleteVacation} from '../../actions/vacations';
import {getUsers} from '../../actions/users';
import moment from 'moment';
import _ from 'lodash';


class Vacations extends Component {

    constructor(props) {
        super(props);
        this._onClickCancelVacation = this._onClickCancelVacation.bind(this);
        this._onClickApproveVacation = this._onClickApproveVacation.bind(this);
        this._onClickDeleteVacation = this._onClickDeleteVacation.bind(this);

    }


    _onClickCancelVacation(vacation) {
        let data = {status: 'canceled'};
        this.props.dispatch(editVacation(()=> {}, vacation._id, data));
    }

    _onClickDeleteVacation(vacation) {
        this.props.dispatch(deleteVacation(()=> {}, vacation._id));
    }

    _onClickApproveVacation(vacation) {
        let data = {status: 'approved'};
        this.props.dispatch(editVacation(()=> {}, vacation._id, data));
    }

    componentWillMount() {
        this.props.dispatch(getVacations());
        this.props.dispatch(getUsers());
    }

    _badge(status) {
        return <span className={'Badge Badge--' + status}>{status}</span>;
    }

    render() {
        let requests = [];
        let upcoming = [];
        let canceled = [];
        let past = [];

        if (this.props.vacations.length) {
            this.props.vacations.forEach((vacation, index) => {

                let startAt = moment(vacation.startAt).format("DD/MM/YYYY");
                let endAt = moment(vacation.endAt).format("DD/MM/YYYY");

                // skip previous years vacations
                if (moment(vacation.startAt).isBefore(moment(), 'year')) {
                    return;
                }
                let user = _.find(this.props.users, {_id: vacation.userId});
                let approvedBy = {};
                let canceledBy = {};
                if (vacation.canceledBy) {
                    canceledBy = _.find(this.props.users, {_id: vacation.canceledBy}) || {};
                }
                if (vacation.approvedBy) {
                    approvedBy = _.find(this.props.users, {_id: vacation.approvedBy}) || {};
                }

                let firstName = (user && user.firstName) || '';
                let lastName = (user && user.lastName) || '';
                let name = (firstName + ' ' + lastName).trim() || '—';

                const nameCell = (
                    <td><div className="User-Cell"><span className="color-dot" style={{background: (user && user.color) || '#cbd5cf'}} /> {name}</div></td>
                );
                const approveCancelActions = (
                    <td>
                        <div className="Row-Actions">
                            <button className="btn btn-default" title="Approve vacation" onClick={()=> this._onClickApproveVacation(vacation)}>
                                <i className="fa fa-check" aria-hidden="true" style={{color:'var(--success)'}}></i>
                            </button>
                            <button className="btn btn-default" title="Cancel vacation" onClick={()=> this._onClickCancelVacation(vacation)}>
                                <i className="fa fa-times" aria-hidden="true" style={{color:'var(--danger)'}}></i>
                            </button>
                        </div>
                    </td>
                );

                if (vacation.status === 'canceled') {
                    canceled.push(<tr key={'canceled_vacations_' + index}>
                        {nameCell}
                        <td className="tabular">{startAt}</td>
                        <td className="tabular">{endAt}</td>
                        <td className="tabular">{vacation.days}</td>
                        <td>{this._badge(vacation.status)}</td>
                        <td className="text-muted-2">{canceledBy.email || '—'}</td>
                        <td><button className="btn btn-default" title="Delete vacation" onClick={()=> this._onClickDeleteVacation(vacation)}>
                            <i className="fa fa-trash" aria-hidden="true" style={{color:'var(--danger)'}}></i>
                        </button></td>
                    </tr>);
                } else {
                    if (moment().isBefore(vacation.startAt)) {
                        if (vacation.status === 'approved') {
                            upcoming.push(<tr key={'upcoming_vacations_' + index}>
                                {nameCell}
                                <td className="tabular">{startAt}</td>
                                <td className="tabular">{endAt}</td>
                                <td className="tabular">{vacation.days}</td>
                                <td>{this._badge(vacation.status)}</td>
                                <td className="text-muted-2">{approvedBy.email || '—'}</td>
                                <td><button className="btn btn-default" title="Cancel vacation" onClick={()=> this._onClickCancelVacation(vacation)}>
                                    <i className="fa fa-times" aria-hidden="true" style={{color:'var(--danger)'}}></i>
                                </button></td>
                            </tr>);
                        } else if (vacation.status === 'open') {
                            requests.push(<tr key={'requests_vacations_' + index}>
                                {nameCell}
                                <td className="tabular">{startAt}</td>
                                <td className="tabular">{endAt}</td>
                                <td className="tabular">{vacation.days}</td>
                                <td>{this._badge(vacation.status)}</td>
                                {approveCancelActions}
                            </tr>);
                        }
                    } else {
                        if (vacation.status === 'open') {
                            past.push(<tr key={'past_vacations_' + index}>
                                {nameCell}
                                <td className="tabular">{startAt}</td>
                                <td className="tabular">{endAt}</td>
                                <td className="tabular">{vacation.days}</td>
                                <td>{this._badge(vacation.status)}</td>
                                <td className="text-muted-2">{approvedBy.email || '—'}</td>
                                {approveCancelActions}
                            </tr>);
                        } else {
                            past.push(<tr key={'past_vacations_' + index}>
                                {nameCell}
                                <td className="tabular">{startAt}</td>
                                <td className="tabular">{endAt}</td>
                                <td className="tabular">{vacation.days}</td>
                                <td>{this._badge(vacation.status)}</td>
                                <td className="text-muted-2">{approvedBy.email || '—'}</td>
                                <td></td>
                            </tr>);
                        }
                    }
                }

            });
        }

        const emptyRow = (key, cols, msg) => (
            <tr key={key}><td colSpan={cols}><div className="Empty"><i className="fa fa-suitcase" /><div className="t">{msg}</div></div></td></tr>
        );
        if (!requests.length) { requests.push(emptyRow('requests_empty', 6, 'No pending requests')); }
        if (!upcoming.length) { upcoming.push(emptyRow('upcoming_empty', 7, 'No upcoming vacations')); }
        if (!past.length) { past.push(emptyRow('past_empty', 7, 'Nothing here yet')); }
        if (!canceled.length) { canceled.push(emptyRow('canceled_empty', 7, 'No canceled vacations')); }

        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Pending requests</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{requests}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Upcoming vacations</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Approved by</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{upcoming}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Past vacations</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Approved by</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{past}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Canceled vacations</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">User</th>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Canceled by</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{canceled}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

Vacations.propTypes = {
    vacations: PropTypes.arrayOf(PropTypes.object),
    users: PropTypes.arrayOf(PropTypes.object),
};

Vacations.defaultProps = {
    vacations: [],
    users: [],
};

function mapStateToProps(state) {
    const vacations = state.vacations;
    const users = state.users;
    return {
        users: users,
        vacations: vacations,
    };
}

export default connect(mapStateToProps)(Vacations);



// WEBPACK FOOTER //
// ./src/screens/Vacations/index.js